<template>
  <div class="AddressForm">
    <div class="AddressForm__label">{{ title }}</div>
    <slot></slot>
    <div class="AddressForm__input">
      <div class="InputGroup InputGroup--xsmall">
        <label class="InputGroup__label">Nom <sup>*</sup></label>
        <Input
          :required="true"
          v-model="localAddress.name"
          name="name"
        />
      </div>
    </div>
    <div class="AddressForm__input">
      <div class="InputGroup InputGroup--xsmall">
        <label class="InputGroup__label">Adresse <sup>*</sup></label>
        <Input
          :required="true"
          v-model="localAddress.address"
          name="address"
        />
      </div>
    </div>
    <div class="AddressForm__city-infos">
      <div class="InputGroup InputGroup--xsmall AddressForm__cp">
        <label class="InputGroup__label">Code postal <sup>*</sup></label>
        <Input
          :required="true"
          v-model="localAddress.zipcode"
          name="cp"
        />
      </div>
      <div class="InputGroup InputGroup--xsmall">
        <label class="InputGroup__label">Ville <sup>*</sup></label>
        <Input
          :required="true"
          v-model="localAddress.city"
          name="city"
        />
      </div>
    </div>
    <div class="AddressForm__city-infos">
      <div class="InputGroup InputGroup--xsmall AddressForm__cedex">
        <label class="InputGroup__label">Cedex</label>
        <Input
          v-model="localAddress.cedex"
          name="cedex"
        />
      </div>
      <div class="InputGroup InputGroup--xsmall">
        <label class="InputGroup__label">Pays <sup>*</sup></label>
        <select v-model="localAddress.country" class="Select Select--variant Select--small">
          <option
            v-for="country in countries"
            :key="country.alpha2Code"
            :value="country.alpha2Code"
          >
            {{ country.name }}
          </option>
        </select>
      </div>
    </div>
    <div class="AddressForm__input">
      <div class="InputGroup InputGroup--xsmall">
        <label class="InputGroup__label">Infos supplémentaires</label>
        <Input
          v-model="localAddress.additional_info"
          name="address"
        />
      </div>
    </div>
    <div class="AddressForm__footer">
      <div class="AddressForm__cancel Button Button--small" @click="$emit('cancel')">Annuler</div>
      <div @click="$emit('save')" class="AddressForm__confirm Button Button--small Button--primary">Confirmer</div>
    </div>
  </div>
</template>

<script>
import countries from "../utils/countries";
import Input from "./Input";

export default {
  props: {
    value: {
      type: Object,
      required: true
    },
    addresses: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      localAddress: null,
      countries
    };
  },
  watch: {
    value: {
      handler() {
        this.localAddress = this.value;
      },
      immediate: true
    },
    localAddress() {
      this.$emit("input", this.localAddress);
    }
  },
  components: {
    Input
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/_variables.scss';

.AddressForm {
  &__label {
    font-size: 0.9rem;
    margin-bottom: $global-margin;
  }

  &__select {
    margin-bottom: $global-margin;
  }

  &__input {
    margin-bottom: $global-margin;
  }

  &__city-infos {
    display: flex;
  }

  &__cp,
  &__cedex {
    width: 100px;
    margin-right: $global-margin;
    flex-grow: 0;
    flex-shrink: 0;
  }

  &__new {
    margin-right: auto;
    font-size: 0.8rem;
    text-decoration: underline;
  }

  &__footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .Button {
      margin-left: $global-margin;
    }
  }
}
</style>
